const step = 5;

export enum StackingContext {
  Below = -1,
  Base = StackingContext.Below + step,
  Above = StackingContext.Base + step,
}

// Layout dependency
export const zLoaderContainer = StackingContext.Base;
export const zBatchGridOverlay = StackingContext.Base;
export const zBatchSidebar = StackingContext.Base;
export const zBatchLoader = StackingContext.Base + step;

export const zSliderArrows = StackingContext.Above;
export const zSelectionWhiteBorderSudo = StackingContext.Above;
export const zCanvasLayer = StackingContext.Above;
export const zVisibilitySidebarIcon = zCanvasLayer + step;
export const zCanvasButtonsWrapper = zCanvasLayer + step;
export const zToolbarSettingsContainer = zCanvasButtonsWrapper;
export const zDialog = zSliderArrows + step;
export const zDropdownContent = zDialog + step;
export const zEraserPage = zVisibilitySidebarIcon + step;
export const zDropdownActionsWrapper = zToolbarSettingsContainer + step;
export const zObjectRemoverPage = zDropdownActionsWrapper + step;
export const zWebWidget = zObjectRemoverPage + step;
export const zNotifierHolder = zWebWidget + step;
export const zShareModalOverlay = zWebWidget + step;
export const zBatchDragOverlay = zBatchGridOverlay + step;
export const zBatchPadding = zBatchSidebar + step;
export const zBatchSocial = zBatchSidebar + step;
export const zBatchSocialWrapper = zBatchSocial + step;
export const zBatchDropdown = zBatchSocialWrapper + step;
export const zBatchPicker = zBatchSocialWrapper + step;
export const zThemeSettings = zEraserPage + step;
